export const url = 'https://fomo-fashion-capstone.onrender.com'